import { Directive, ElementRef, Input } from '@angular/core';

import { Files } from '@core/interfaces/claims/files.interface';
import { ThumbnailRefreshService } from '@core/services/thumbnail-refresh.service';

const BROKEN_IMAGE_ICON = 'assets/icons/icon-brokenimage.svg';

@Directive({
  selector: '[appImageErrorStandalone]',
  standalone: true,
})
export class ImageErrorStandaloneDirective {
  @Input() file: Files;

  constructor(el: ElementRef, private readonly thumbnailRefreshService: ThumbnailRefreshService) {
    el.nativeElement.onerror = (event): void => {
      if (window.navigator.onLine && !event.target.src.includes(BROKEN_IMAGE_ICON)) {
        const failedSrc = event.target.src;
        event.target.src = BROKEN_IMAGE_ICON;
        if (this.file) {
          this.file.loadFailed = true;
        }
        this.thumbnailRefreshService.notifyThumbnailFailed(failedSrc);
      }
    };
  }
}
